//Include Both Helper File with needed methods
// import { getFirebaseBackend } from "../../../helpers/firebase_helper";
// import { postFakeProfile, postJwtProfile } from "../../../helpers/fakebackend_helper";

// action
import { getMyAccount } from 'services/authService';
import { userSuccess, userError } from './reducer';

export const getUser = () => async (dispatch: any) => {
  try {
    const response = await getMyAccount();
    if (response) {
      dispatch(userSuccess({ status: true, data: response }));
    } else {
      dispatch(userError('Failed to fetch user data.'));
    }
  } catch {
    dispatch(userError('Error fetching user data.'));
  }
};

// export const editUser = (user: any) => async (dispatch: any) => {
//   try {
//     let response;

//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       response = fireBaseBackend.editUserAPI(user.first_name, user.idx);
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
//       response = postJwtUser({
//         username: user.username,
//         idx: user.idx,
//       });
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
//       response = postFakeUser(user);
//     }

//     const data = await response;

//     if (data) {
//       dispatch(userSuccess(data));
//     }
//   } catch (error) {
//     dispatch(userError(error));
//   }
// };

// export const resetUserFlag = () => {
//   try {
//     const response = resetUserFlagChange();
//     return response;
//   } catch (error) {
//     return error;
//   }
// };
